import React from "react";
import "./bannerDivider.scss";

/**
 * BannerDivider Component
 * @param {Object} props - Component props
 * @param {string} props.text - Text to display in the banner divider
 * @returns {JSX.Element} BannerDivider component
 */
const BannerDivider = ({ text }) => {
  return (
    <div className="bannerDividerContainer">
      <p className="bannerDividerText">{text}</p>
    </div>
  );
};

export default BannerDivider;
